var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 34,
    "data-testid": "magma-swap-logo",
    className: "rgw6ez44l rgw6ez4cl",
    viewBox: "0 0 340 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.356 159.325C336.097 76.691 264.709 6.121 182.715.526 97.61-6.433 16.335 56.35 2.502 140.79 2.04 146.053.439 150.877.6 156.183c-.664 9.999-1.754 20.72 2.993 30.008 19.88 36.056 73.074 45.337 110.516 51.159 26.935 3.914 42.428 4.268 81.299 2.982 45.983-1.522 153.815-16.439 143.96-81.027l-.011.02zm-37.276 6.917c-21.394 34.472-90.6 35.405-126.703 32.031-31.228-2.919-63.267-7.488-77.605-32.301-2.312-4.956-2.362-11.162-1.72-16.498.904-23.38 10.923-46.152 26.635-63.409 18.394-20.824 45.79-32.944 73.401-34.191 45.923-2.07 90.762 29.095 103.549 73.509 3.332 10.863 7.289 30.42 2.443 40.857z",
    fill: "#ea462b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagma);
export default __webpack_public_path__ + "static/media/magma.a9a6e47966e3473897f04dd95919c760.svg";
export { ForwardRef as ReactComponent };